import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, children }) => (
  <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand">
    {index && <span className="mr-2 font-mono text-navy/30">{index}</span>}
    {children}
  </p>
);
